module.exports = __webpack_public_path__ + "static/media/a'22Header1.c72efa57.png";